// import $g from './Global'
import axios from 'axios'
import { param } from 'jquery'
// import Url from './Url'
// import base from './Base'


let Url = cx.url
let base = cx.base
let qs = require('qs')
let CryptoJS = require('crypto-js')

let secretKey = ''
let count = Math.floor(Math.round(Math.random() * 50))
let bUrlCrypt = false
let auth = ''

let encrypt = (params, bURI) =>
{
  let key, i = 0
  let str = '', value
  let authValue = params._auth // 保存 _auth 值
  for (key in params)
  {
    switch (typeof params[key])
    {
    case 'object':
    case 'array':
      value = JSON.stringify(params[key])
      break
    default:
      value = params[key]
      break
    }
    str += (i > 0 ? '&' : '') + key + '=' + value
    i++

    delete params[key]
  }
  secretKey = (count + 'z@!1~_B').substr(0, 8)
  params.count = count
  params._auth = authValue // 重新添加 _auth
  params.code = CryptoJS.DES.encrypt(str, CryptoJS.enc.Utf8.parse(secretKey),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
  if (bURI)
    params.code = encodeURIComponent(params.code)
  count++
}

let decrypt = (str) =>
{
  return CryptoJS.DES.decrypt(
    {ciphertext: CryptoJS.enc.Base64.parse(str)},
    CryptoJS.enc.Utf8.parse('_zB1~!@#'),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
}

let sqlArgs = (params) =>
{
  let str = '', oper, conc, arg

  for (arg of params.args)
  {
    switch (arg[1].toUpperCase())
    {
    case '=':   oper = 1;   break
    case '!=':  oper = 2;   break
    case '>':   oper = 3;   break
    case '>=':  oper = 4;   break
    case '<':   oper = 5;   break
    case '<=':  oper = 6;   break
    case 'LIKE':  oper = 7; break
    case 'IS NULL': oper = 8; break
    case 'IS NOT NULL': oper = 9; break
    case 'IN':  oper = 10;  break
    default: oper = 0;      break
    }
    conc = (arg[3] === undefined || arg[3] === null ? '' : arg[3]).toUpperCase()
    switch (conc)
    {
    case 'AND': conc = 1; break
    case 'OR':  conc = 2; break
    default:    conc = 0; break
    }

    str += (str ? ';' : '') + arg[0] +
      ':@:' + oper +
      ':@:' + (arg[2] === undefined || arg[2] === null || arg[2] === '' ? 'null' : arg[2]) +
      ':@:' + conc
  }
  params.args = str
}

/**
 * cx.http
 * 类-异步请求类
 *
 * @class
 * @memberof    cx
 * @author      Zhang Fayong
 * @since       2018-04-27
 */
class Http
{
  /**
   * 初始化
   * @static
   * @method
   */
  static init()
  {
    axios.defaults.withCredentials = true
  }

  /**
   * 全局错误处理
   * @private
   * @static
   * @method
   * @param   {Object}    data        传入错误的数据
   */
  static _error(data)
  {
    console.log(data)
  }

  /**
   * 判断是否返回数据
   * @private
   * @static
   * @method
   * @param   {*}         data        接收到的数据
   * @returns {Boolean}
   */
  static _isStatus(data)
  {
    if (data.code === 100)
      return false
    else
      return true
  }

  /**
   * 设置URL是否进行加密
   * @static
   * @param   {Boolean}   bCrypt            是否加密传输URL
   */
  static setUrlCrypt(bCrypt)
  {
    bUrlCrypt = bCrypt
  }

  /**
   * 设置授权信息
   * @static
   * @param   {String}      info            设置授权信息
   */
  static setAuth(info)
  {
    auth = info
  }

  /**
   * 取授权信息
   * @static
   * @returns {String}
   */
  static getAuth()
  {
    return auth
  }

  static urlGet(url, params)
  {
    //2021-5-27 张清  拷贝对象，避免业务层的params被修改
    let mixParams = base.extend({}, params)
    if (bUrlCrypt)
      encrypt(mixParams, true)
    if (auth)
      mixParams._auth = auth

    return Url.getRequestUrl(url, mixParams)
  }

  /**
   * GET方式调用
   * @method
   * @static
   * @param   {String}    url         URL
   * @param   {Object}    [params]    请求参数，如果url中已通过 ? 配置参数，如 http://地址:端口/LoginSvr?key1=参数1。相同参数，params中优先级高
   * @param   {Object}    [urlConf]   请求的配置数据
   * @returns {Promise}
   */
  static get(url, params = {}, urlConf)
  {
    return new Promise((resolve, reject) =>
    {
      let urlData = Url.getUrlParams(url)
      let mixParams = {}
      if (url.split('?')[1])
      {
        //url中有参数
        Object.assign(mixParams, urlData.params, params)
      }

      if (mixParams.args)
        sqlArgs(mixParams)
      if (auth)
        mixParams._auth = auth

      if (bUrlCrypt)
        encrypt(mixParams, true)


      axios.get(Url.getRequestUrl(urlData.baseUrl, mixParams), urlConf)
        .then((ret) =>
        {
          if (this._isStatus(ret.data))
            resolve(ret.data)
        })
        .catch((ret) =>
        {
          this._error(ret)
          reject(ret)
        })
    })
  }

  /**
   * POST方式调用
   * @method
   * @static
   * @param   {String}    url         URL
   * @param   {Object}    params      参数
   * @param   {Object}    [urlConf]   请求的配置数据
   * @returns {Promise}
   */
  static post(url, params, urlConf)
  {
    let mixParams = base.extend({}, params)
    if (mixParams.args)
      sqlArgs(mixParams)
    if (auth)
      mixParams._auth = auth
    if (bUrlCrypt && !url.includes('LoginSvr'))
      encrypt(mixParams)

    return axios.post(url, qs.stringify(mixParams), urlConf)
      .then((ret) =>
      {
        let data = ret.data

        if (data && data[0] && data[0]._encoded)
        {
          data = decrypt(data[0]._encoded)
          data = eval('(' + data + ')')

          if (typeof data === 'object' && data.length === undefined)
            data = [data]
        }

        if (this._isStatus(data))
        {
          if (data && data[0] && data[0].ret !== undefined)
            return data[0]
        }
        return data
      })
      .catch((ret) =>
      {
        this._error(ret)
      })
  }

  /**
   * GET方式调用
   * @method
   * @static
   * @param   {String}    url                             URL
   * @returns {Promise}
   */
  static loadText(url)
  {
    return new Promise((resolve, reject) =>
    {
      axios({url: url, data: {}, config: {responseType: 'text'}})
        .then((ret) =>
        {
          if (this._isStatus(ret.data))
            resolve(ret.data)
        })
        .catch((ret) =>
        {
          reject(ret)
        })
    }).catch((ret) =>
    {
      return ret
    })
  }

  /**
   * GET方式调用
   * @method
   * @static
   * @param   {String}    url                             URL
   * @returns {Promise}
   */
  static loadBinary(url)
  {
    return new Promise((resolve, reject) =>
    {
      axios({url: url, data: {}, config: {responseType: 'arraybuffer'}})
        .then((ret) =>
        {
          if (this._isStatus(ret.data))
            resolve(ret.data)
        })
        .catch((ret) =>
        {
          reject(ret)
        })
    }).catch((ret) =>
    {
    })
  }
}

axios.defaults.withCredentials = true

Http.CryptoJS = require('crypto-js')

export default Http



// WEBPACK FOOTER //
// ./src/lib/Http.js